import { observer } from 'mobx-react';
import { useEffect, useMemo, useRef } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { IResponseProductModifier, IResponseProductModifierOption } from 'src/types/products';
import MultiChoice from '~/view/components/Controls/MultiChoice/MultiChoice';
import SingleChoice from '~/view/components/Controls/SingleChoice/SingleChoice';

interface IProps {
  modifier: IResponseProductModifier;
  isModifierWithError: boolean;
  onChangeModifier: (modifier: IResponseProductModifier) => void;
}

const ProductModifier: React.FC<IProps> = observer(({ modifier, isModifierWithError, ...props }: IProps): JSX.Element => {
  const modifierContainerRef = useRef<HTMLDivElement>(null);

  const optionsLeftToMaximum = useMemo((): number => {
    const numberOfSelectedOptions = modifier.options.reduce((count: number, option: IResponseProductModifierOption) => {
      if (option.selected) {
        count = count + option.quantity;
      }
      return count;
    }, 0);

    // maximum = 0 = infinity
    if (!modifier.maximum) return 1;

    return modifier.maximum - numberOfSelectedOptions;
  }, [modifier]);

  useEffect(() => {
    scrollOnModifierWithError();
  }, [isModifierWithError, orderProductModalStore.needScrollToError]);

  const scrollOnModifierWithError = () => {
    if (isModifierWithError && orderProductModalStore.needScrollToError) {
      modifierContainerRef.current?.scrollIntoView({ behavior: 'smooth' });
      orderProductModalStore.setNeedScrollToError(false);
    }
  };

  const ModifierComponent = modifier.multi_choice ? MultiChoice : SingleChoice;

  return (
    <div ref={modifierContainerRef}>
      <ModifierComponent
        modifier={modifier}
        onChange={props.onChangeModifier}
        error={isModifierWithError}
        leftToMaximum={optionsLeftToMaximum}
        currencySettings={orderProductModalStore.currencySettings}
      />
    </div>
  );
});

export default ProductModifier;
